import axios from "../helper/AxiosHelper";

const list = async (page, pageSize, filters) => {
  const query = {
    filters: filters || undefined,
    page: page || 1,
    page_size: pageSize || 10,
  };
  const response = await axios.get(
    `/promotion/query?query=${JSON.stringify(query)}`
  );
  const result = response.data.result;

  return {
    data: result.data.map((data) => {
      return {
        id: data.id,
        name: data.name,
        startAt: data.start_at,
        endAt: data.end_at,
        logicType: data.logic_type,
        reqMemberLevel: data.req_member_level,
        parameter: data.parameter,
        updatedAt: data.updated_at,
      };
    }),
    page: result.page,
    pageSize: result.page_size,
    total: result.total,
  };
};

const details = async (id) => {
  const response = await axios.get(`/promotion/show/${id}`);
  const result = response.data.result;
  return {
    id: result.record.id,
    name: result.record.name,
    startAt: result.record.start_at,
    endAt: result.record.end_at,
    logicType: result.record.logic_type,
    reqMemberLevel: result.record.req_member_level,
    parameter: result.record.parameter,
  };
};

export const PromotionApi = {
  list,
  details,
};
